<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 平台监控</span>
      </div>
      <div style="padding-top: 15px; color: #606266">
        <div>
          <h3>综合统计</h3>
        </div>
        <div style="text-align: left">
          <table width="100%">
            <tr>
              <th style="padding: 10px; background-color: #f8f8f8">总接口数量</th>
              <th style="padding: 10px; background-color: #f8f8f8">总请求次数</th>
              <th style="padding: 10px; background-color: #f8f8f8">成功请求次数</th>
              <th style="padding: 10px; background-color: #f8f8f8">失败请求次数</th>
              <th style="padding: 10px; background-color: #f8f8f8">平均响应时间（毫秒）</th>
              <th style="padding: 10px; background-color: #f8f8f8">当前并发请求数</th>
              <th style="padding: 10px; background-color: #f8f8f8">峰值并发请求数</th>
              <th style="padding: 10px; background-color: #f8f8f8">峰值出现时间</th>
            </tr>
            <tr>
              <td style="padding: 10px; background-color: #ffffff;font-weight: bold">{{ statistics.totalEndpoints }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ statistics.totalRequests }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ statistics.totalSuccess }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ statistics.totalErrors }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ statistics.averageResponseTime.toFixed(2) }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ statistics.concurrentStats.currentConcurrentRequests }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ statistics.concurrentStats.peakConcurrentRequests }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ formattedTime(statistics.concurrentStats.peakTime) }}</td>
            </tr>

          </table>
        </div>

        <div>
          <h3>热门接口</h3>
        </div>
        <div style="text-align: left">
          <table width="100%">
            <tr>
              <th style="padding: 10px; background-color: #f8f8f8">接口路由地址</th>
              <th style="padding: 10px; background-color: #f8f8f8">HTTP方法</th>
              <th style="padding: 10px; background-color: #f8f8f8">总点击次数</th>
              <th style="padding: 10px; background-color: #f8f8f8">成功次数</th>
              <th style="padding: 10px; background-color: #f8f8f8">失败次数</th>
              <th style="padding: 10px; background-color: #f8f8f8">平均响应时间（毫秒）</th>
              <th style="padding: 10px; background-color: #f8f8f8">首次访问时间</th>
              <th style="padding: 10px; background-color: #f8f8f8">最后访问时间</th>
            </tr>
            <tr :key="index" :style="{display:value.httpMethod=='OPTIONS'?'none':''}" v-for="(value,index) in statistics.topEndpoints">
              <td style="padding: 10px; background-color: #ffffff;font-weight: bold">{{ value.route }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ value.httpMethod }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ value.totalHits }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ value.successHits }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ value.errorHits }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ value.averageResponseTimeMs.toFixed(2) }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ formattedTime(value.firstAccess) }}</td>
              <td style="padding: 10px; background-color: #ffffff">{{ formattedTime(value.lastAccess) }}</td>
            </tr>

          </table>
        </div>

        <div style="padding-top: 15px;">
          <h3>最近访问记录</h3>
        </div>
        <div style="padding-top: 15px;">
          <div>
            <table width="100%">
              <tr>
                <th class="th">
                  接口路由地址
                </th>
                <th class="th">
                  请求时间
                </th>
                <th class="th">
                  客户端IP地址
                </th>
                <th class="th">
                  HTTP请求方法
                </th>
                <th class="th">
                  请求唯一标识符
                </th>
                <th class="th">是否成功</th>
                <th class="th">查询字符串</th>
                <th class="th">响应时间（毫秒）</th>
                <th class="th">HTTP状态码</th>
                <th class="th">用户代理（浏览器信息）</th>
              </tr>
              <tr :key="index" :style="{display:(value.httpMethod=='OPTIONS'||value.route=='/dataCount/TodayDataCount'
              ||value.route=='/topUp/GetTopUpWaitSendCard'||value.route=='/api/monitoring/statistics'
              ||value.route=='/api/monitoring/recent-accesses')?'none':''}" v-for="(value,index) in list">
                <td class="td">
                  {{value.route}}
                </td>
                <td class="td" style="min-width: 50px;">
                  {{ formattedTime(value.accessTime) }}
                </td>
                <td class="td">
                  {{ value.clientIP }}
                </td>
                <td class="td">
                  {{ value.httpMethod }}
                </td>
                <td class="td">{{ value.id }}</td>
                <td class="td">{{ value.isSuccess }}</td>
                <td class="td">{{ value.queryString }}</td>
                <td class="td">{{ value.responseTimeMs.toFixed(2) }}</td>
                <td class="td">{{ value.statusCode }}</td>
                <td class="td">{{ value.userAgent }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "SystemMessage",
  data(){
    return{
      statistics:null,
      list:null,
      timer:null,
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
    axiosGet(DO_NET_URL+"api/monitoring/statistics",function (res){
      //res=res
      console.log(res)
      that.statistics=res
    })
    axiosGet(DO_NET_URL+"api/monitoring/recent-accesses",function (res){
      //res=res
      console.log(res)
      that.list=res
    })
    this.timer = setInterval(() => {
      axiosGet(DO_NET_URL+"api/monitoring/statistics",function (res){
        //res=res
        console.log(res)
        that.statistics=res
      })
      axiosGet(DO_NET_URL+"api/monitoring/recent-accesses",function (res){
        //res=res
        console.log(res)
        that.list=res
      })
    }, 10000)


  },
  beforeDestroy() {
    // 清理定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
      console.log('定时器已清理')
    }
  },
  methods: {
    formattedTime(isoTime) {
      const date = new Date(isoTime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    updatePwd(){
      let that=this
      if(this.oldPwd==""){
        toask("请输入原密码！",6)
        return
      }
      if(this.newPwd==""){
        toask("请输入新密码！",6)
        return
      }
      if(this.nextPwd==""){
        toask("请再次输入新密码！",6)
        return
      }
      if(this.newPwd.length<6){
        toask("密码最少为6位！",6)
        return
      }
      if(this.newPwd!=this.nextPwd){
        toask("两次密码输入不一致！",6)
        return
      }
      loading("请求中")
      axiosPost(DO_NET_URL+"Admin/UpdatePwdByAdmin?oldPwd="+this.oldPwd+"&newPwd="+this.newPwd,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("密码修改成功！",6)
          setTimeout(function (){
            that.$router.replace('index')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>